import { useState } from 'react';

const pizzas = [
  {
    name: 'Vegetarijanska pica',
    ingredients: 'zelenjava, pelati, sir',
  },
  {
    name: 'Pica z morskimi sadeži',
    ingredients: 'morski sadeži, školjke, pelati, sir, olive, česnov preliv',
  },
  {
    name: 'Pica s tuno',
    ingredients: 'tuna, pelati, sir, čebula, olive',
  },
  {
    name: 'Pica margerita',
    ingredients: 'sir, pelati, olive',
  },
  {
    name: 'Pica s čevapčiči',
    ingredients: 'šunka, pelati, sir, čevapčiči, gobice',
  },
  {
    name: 'Ocvirkovka',
    ingredients: 'ocvirki, sir, česen',
  },
  {
    name: 'Družinska pica',
    ingredients: 'šunka, pelati, sir, gobice',
  },
  {
    name: 'Družinska pica mešana',
    ingredients: '',
  },
  {
    name: 'Družinska kebab pica',
    ingredients: '',
  },
  {
    name: 'Družinska ocvirkovka',
    ingredients: '',
  },
  {
    name: 'Pica z jeziki',
    ingredients: 'šunka, jeziki, sir, gobice, pelati',
  },
  {
    name: 'Kmečka pica',
    ingredients: 'šunka, pelati, slanina, sir, gobice, česen',
  },
  {
    name: 'Pica salami',
    ingredients: 'šunka, pelati, sir, salama, gobice',
  },
  {
    name: 'Pica s šunko',
    ingredients: 'šunka, pelati, sir, gobice',
  },
  {
    name: 'Pica pikant',
    ingredients: 'šunka, pelati, šunka, sir, gobice, feferon',
  },
  {
    name: 'Moška pica',
    ingredients: 'šunka, pelati, sir, gobice, česnov preliv',
  },
  {
    name: 'Kraška pica',
    ingredients: 'šunka, pelati, sir, pršut, olive',
  },
  {
    name: 'Štajerska pica',
    ingredients: 'šunka, pelati, sir, čebula, jajce, gobice',
  },
  {
    name: 'Bela dama',
    ingredients: 'šunka, pelati, sir, kisla smetana, gobice',
  },
  {
    name: 'Kmetova pica',
    ingredients: 'šunka, pelati, jeziki, slanina, kisla smetana, sir, gobice',
  },
  {
    name: 'Mehiška pica',
    ingredients: 'mleto meso, pelati, paprika, fižol, koruza, nacho sir',
  },
  {
    name: 'Otroška pica',
    ingredients: 'šunka, pelati, sir, gobice',
  },
  {
    name: 'Pica Kebab',
    ingredients: 'piščančji kebab, koruza, paprika, čebula, solata, zelje, kebab omaka',
  },
  {
    name: 'Prleška pica',
    ingredients: 'tunka, pelati, gobice, paprika, čebula, sir',
  },
];

type TabId = 'pice';

const tabs: { id: TabId; label: string; icon: string }[] = [
  { id: 'pice', label: 'PICE', icon: 'ri-restaurant-2-line' },
];

export default function MenuSection() {
  const [openTab, setOpenTab] = useState<TabId | null>(null);

  const toggleTab = (id: TabId) => {
    setOpenTab((current) => (current === id ? null : id));
  };

  return (
    <section id="ponudba" className="relative bg-background-50 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="relative w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
              PONUDBA
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-4">
              Naš jedilnik
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
              Izberi kategorijo in poglej, kaj smo pripravili zate.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mb-8 md:mb-10">
            {tabs.map((tab) => {
              const active = openTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => toggleTab(tab.id)}
                  aria-expanded={active}
                  className={`inline-flex items-center gap-2 px-6 py-3 border font-label text-xs font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md ${
                    active
                      ? 'bg-accent-500 text-background-50 border-accent-500'
                      : 'bg-background-100 text-foreground-800 border-background-200 hover:border-accent-400 hover:text-accent-700'
                  }`}
                >
                  <i className={`${tab.icon} text-base`}></i>
                  {tab.label}
                  <i
                    className={`ri-arrow-down-s-line text-base transition-transform duration-300 ${
                      active ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
              );
            })}
          </div>

          {openTab === 'pice' ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              {pizzas.map((pizza, idx) => (
                <div
                  key={pizza.name}
                  className="menu-item group relative bg-background-100 hover:bg-background-200/80 border border-background-200/70 rounded-lg p-6 md:p-7 transition-all duration-300 hover:border-accent-300/50"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 group-hover:scale-110 bg-accent-500/10">
                      <i className="fa-solid fa-pizza-slice text-accent-600 text-lg md:text-xl"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-baseline gap-3">
                        <span className="font-label text-[11px] font-medium text-foreground-400">
                          {String(idx + 1).padStart(2, '0')}
                        </span>
                        <h3 className="font-heading text-lg md:text-xl font-medium text-foreground-900 transition-colors duration-300 group-hover:text-accent-700">
                          {pizza.name}
                        </h3>
                      </div>
                      {pizza.ingredients ? (
                        <p className="font-body text-xs md:text-sm text-foreground-600 leading-relaxed mt-1.5">
                          {pizza.ingredients}
                        </p>
                      ) : (
                        <p className="font-body text-xs md:text-sm text-foreground-400 italic leading-relaxed mt-1.5">
                          Sestavine na vprašanje
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-accent-500 transition-transform duration-400 origin-left scale-x-0 group-hover:scale-x-100 rounded-b-lg"></div>
                </div>
              ))}
            </div>
          ) : (
            <p className="font-body text-sm text-foreground-500 text-center py-6">
              Klikni na kategorijo zgoraj, da se prikaže ponudba.
            </p>
          )}

          <div className="text-center mt-10 md:mt-14 space-y-6">
            <p className="font-body text-xs md:text-sm text-foreground-500">
              Ponudba se lahko razlikuje glede na sezono. Za točno ponudbo povprašaj osebje na lokaciji.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}